<template>
  <GeoFencing />
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import GeoFencing from '@/components/content/GeoFencing.vue'

export default defineComponent({
  name: 'GeoFencingView',
  components: { GeoFencing },
  emits: ['pageName'],
  setup(props, context) {
    const i18n = useI18n()

    context.emit('pageName', i18n.t('aside.menu.pages.geofencing'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.geofencing'))
    })
  },
  mounted() {
    document.body.classList.add('geofencing-page')
  },
  unmounted() {
    document.body.classList.remove('geofencing-page')
  }
})
</script>
